<template>
  <v-container fluid class="main-container">
    <v-row class="text-center">

      <v-col cols="12">
        <h1 class="display-2 font-weight-bold mb-3 shadow-text">
          Hello, you found my website!
        </h1>

        <h3 class="subheading font-weight-regular shadow-text">
          My name is Glen Heide. I'm a Software Engineer with over 17 years of professional work experience. My specialties include <b>Client, UI and Tools</b> engineering along with decent full-stack work experience using the latest web technologies and node back-ends.<p/>
          Please check out my Portfolio to see what kind of work I've done over the years.
        </h3>
      </v-col>

      <v-col cols="12">
        <v-btn @click="navigate('portfolio')">
          PORTFOLIO
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-btn @click="navigate('contact')">
          CONTACT ME
        </v-btn>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
  }),

  methods: {
    navigate (target) {
      this.$emit('navigate', target)
    },
  },
}
</script>

<style type="text/css" scoped>
.main-container {
  padding-top: 100px;
  padding-left: 100px;
  padding-right: 100px;
}
</style>

<style type="text/css">
.shadow-text {
  color: #fff;
  text-shadow: 2px 2px 4px rgba(0,0,0,.6);
}
</style>
